import axios from 'axios'

const baseURL = process.env.REACT_APP_API_ENDPOINT_URL

export function login(data) {
  return axios.post(`${baseURL}/api-token-auth/`, data).then((result) => {
    window.localStorage.setItem('__atk__', result.data.token)
  })
}
